import { Injectable } from '@angular/core';
import { IArc } from '../models/IArc';
import { IPolyline } from '../models/ILine';
import { IPoint } from '../models/IPoint';

@Injectable({ providedIn: 'root' })
export class GetPathGeneratorService {
    public getPathGenerator() {
        return new PathGenerator();
    }
}

export class PathGenerator {
    private _actualPath: string;

    constructor(prevPath?: string) {
        this._actualPath = prevPath ? prevPath : '';
    }

    get result() {
        return this._actualPath;
    }

    public addArc(model: IArc, isFirst: boolean, nextPoint: IPoint) {
        let outputStr = '';
        if (isFirst) {
            outputStr += `M ${model.start.x} ${model.start.y} `;
        }
        outputStr += `A ${model.radius} ${model.radius} 0 0 ${
            model.direction === 'Clockwise' ? 1 : 0
        } ${nextPoint.x} ${nextPoint.y} `;
        this._actualPath += outputStr;
    }

    // ALLINEAMENTO B34 - CURVE DI BEZIER

    public addLine(model: IPolyline, isFirst: boolean) {
        let outputStr = '';
        model.points.forEach((p, i) => {
            if (i === 0 && isFirst) {
                outputStr = `M ${p.x} ${p.y} `;
            } else {
                outputStr += p.type ? this.getNewPointMapData(p) : `L ${p.x} ${p.y} `;
            }
        });
        this._actualPath += outputStr;
    }

    // ALLINEAMENTO B34 - CURVE DI BEZIER

    public close() {
        this._actualPath += 'Z';
    }

    //public addLineOld(model: IPolyline, isFirst: boolean) {
    //    let outputStr = 'L ';
    //    model.points.forEach((p, i) => {
    //        if (i === 0 && isFirst) {
    //            outputStr = `M ${p.x} ${p.y} L `;
    //        } else {
    //            outputStr += `${p.x} ${p.y} `;
    //        }
    //    });
    //    this._actualPath += outputStr;
    //}

    private getNewPointMapData(p: IPoint): string {
        let outputStr = '';
        if (p.type === 'L' || p.type === 'M') {
            outputStr = `${p.type} ${p.x} ${p.y} `;
        } else if (p.type === 'Z') {
            outputStr = `${p.type} `;
        } else if (p.type === 'C') {
            outputStr = `${p.type} ${p.x1} ${p.y1} ${p.x2} ${p.y2} ${p.x} ${p.y} `;
        }
        return outputStr;
    }
}
